import React from 'react';
import AddEdit from '../../components/hotel_table/add_edit/Component';

const Component = () => {
  return (
      <AddEdit componentTitle="Hotel Table"/>
  )
}

export default Component
